import EditIcon from '@/assets/icons/edit.svg?react';
import { IconButton } from '@/lib';
import { CheckCircleIcon } from '@heroicons/react/outline';
import { FC } from 'react';

type ChangeCampaignNameButtonProps = {
  isLoading?: boolean;
  isEditingName?: boolean;
  onCampaignRenameConfirm?: VoidFunction;
  onEditClick?: VoidFunction;
};

export const ChangeCampaignNameButton: FC<ChangeCampaignNameButtonProps> = ({ isEditingName, isLoading, onCampaignRenameConfirm, onEditClick }) => {
  if (isEditingName) {
    return (
      <IconButton
        intent='link-grey'
        className='!p-1'
        leadingIcon={<CheckCircleIcon className='size-5 text-brand-600' />}
        isLoading={isLoading}
        onClick={onCampaignRenameConfirm}
      />
    );
  }

  return <IconButton intent='link-grey' className='!p-1' leadingIcon={<EditIcon className='size-5' />} onClick={onEditClick} />;
};
